import { Box, InputLabel, Link, Typography, type SxProps } from '@mui/material'

interface IconLabelProps {
  icon: JSX.Element
  labelText: string
  sx?: SxProps
  labelSx?: SxProps
  labelColor?: string
  whiteSpace?: 'normal' | 'nowrap' | 'pre' | 'pre-wrap' | 'pre-line' | 'break-spaces'
  dataTestId?: string
  labelAsLink?: boolean
}

export const IconWithLabel = (props: IconLabelProps): JSX.Element => {
  return (
    <Box sx={{ ...props.sx, display: 'flex', justifyContent: 'left', flexDirection: 'row', width: '100%' }}>
      {props.icon}
      <InputLabel
        data-testid={props.dataTestId ?? props.labelText}
        sx={{ ...props.labelSx, marginLeft: '.625em', overflowWrap: 'break-word', whiteSpace: props.whiteSpace ?? 'break-spaces', color: props.labelColor ?? 'black' }}
      >
        {props.labelAsLink === true && <Link
          sx={{
            color: 'var(--blue-700)',
            cursor: 'pointer',
            fontSize: '1em',
            alignSelf: 'center',
            overflowWrap: 'break-word',
            whiteSpace: 'break-spaces'
          }}
          onClick={() => {
            window.open(props.labelText, '_blank')
          }}
        >{props.labelText}</Link>}
        {props.labelAsLink !== true && <Typography variant='body1' sx={{ fontSize: '16px' }}>{props.labelText}</Typography>}
      </InputLabel>
    </Box>
  )
}
